import React, { Suspense } from 'react';
import { getMapComponent, DEFAULT_LIBRARY } from './mapConfig';

/**
 * Modular Map Renderer Component
 * Renders the appropriate map component based on library and level
 * 
 * @param {string} library - Library identifier (e.g., 'MSL', 'CLB')
 * @param {number} level - Floor level (1, 2, 3, etc.)
 * @param {string} selectedRoomQuery - Room name to highlight
 * @param {boolean} fullWidth - Whether to render in full width mode
 * @param {object} additionalProps - Any additional props to pass to the map component
 */

const MapRenderer = ({ 
  library = DEFAULT_LIBRARY, 
  level, 
  selectedRoomQuery, 
  fullWidth = false,
  ...additionalProps 
}) => {
  if (!level) return null;

  const MapComponent = getMapComponent(library, level);
  
  if (!MapComponent) {
    console.warn(`No map component found for library: ${library}, level: ${level}`);
    return null;
  }

  return (
    <Suspense fallback={null}>
      <MapComponent 
        selectedRoomQuery={selectedRoomQuery} 
        fullWidth={fullWidth}
        {...additionalProps}
      />
    </Suspense>
  );
};

export default MapRenderer;

